import { render, staticRenderFns } from "./listing-priority.vue?vue&type=template&id=754a5a9e&"
import script from "./listing-priority.vue?vue&type=script&lang=js&"
export * from "./listing-priority.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports